import copy from 'copy-to-clipboard';
import { assert } from '../assert';

/**
 * @description 通用复制方法， 解决 copy-to-clipboard  文本默认复制格式为 text/html 的问题
 * @param text 待复制内容 string
 * @param options copy-to-clipboard 第二个参数，https://www.npmjs.com/package/copy-to-clipboard#api
 */
const mongoIdReg = /\/[a-z0-9]{24}\//;

// 用于检查复制的 URL 中是否含有 24 位的 mongoId，不应该出现这种 URL
function assertMongoId(text: string) {
  assert(!mongoIdReg.test(text), 'potential error, mongo id');
}

export function copyToClipboard(text: string, options = {}): boolean {
  assertMongoId(text);
  return copy(text, { format: 'text/plain', ...options });
}
